import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { Button, TextField, Typography } from "@mui/material";
import { ProvidersService } from "../../services/ProvidersService";

const textFieldStyle = { marginBottom: "10px", marginTop: "10px", background: "white" };

export function PoliciesEditor({ provider, setProvider, showSaveButton = true }) {
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    const handleChange = (evt) => {
        const { name, value } = evt.target;
        setProvider({ ...provider, [name]: value });
        setSaved(false);
    };

    const handleSave = async () => {
        setSaving(true);
        setSaved(false);
        await ProvidersService.updateProvider(provider);
        setSaving(false);
        setSaved(true);
    };

    return (
        <div>
            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "10px" }}>
                These policies will be shown to clients during checkout and must be agreed to before booking.
            </Typography>

            <TextField
                sx={textFieldStyle}
                fullWidth
                multiline
                minRows={5}
                label="Cancellation Policy"
                name="cancellationPolicy"
                variant="outlined"
                onChange={handleChange}
                value={provider?.cancellationPolicy || ""}
                helperText="Describe your cancellation policy. Leave blank if you do not have one."
            />

            <TextField
                sx={textFieldStyle}
                fullWidth
                multiline
                minRows={5}
                label="Late Arrival Policy"
                name="lateArrivalPolicy"
                variant="outlined"
                onChange={handleChange}
                value={provider?.lateArrivalPolicy || ""}
                helperText="Describe your late arrival policy. Leave blank if you do not have one."
            />

            {showSaveButton && (
                <>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={saving}
                        sx={{ marginTop: "10px" }}
                    >
                        {saving ? "Saving..." : "Save"}
                    </Button>

                    {saved && (
                        <Typography variant="body2" color="success.main" sx={{ marginTop: "8px" }}>
                            Policies saved.
                        </Typography>
                    )}
                </>
            )}
        </div>
    );
}

PoliciesEditor.propTypes = {
    provider: PropTypes.shape({
        id: PropTypes.string.isRequired,
        cancellationPolicy: PropTypes.string,
        lateArrivalPolicy: PropTypes.string,
    }).isRequired,
    setProvider: PropTypes.func.isRequired,
    showSaveButton: PropTypes.bool,
};
